import React, { FunctionComponent } from 'react';

import ErrorBoundary from '@justgiving/error-boundary';
import Loading from '@justgiving/loading';

import { AppContext } from '../../context/AppContext';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { captureException } from '@sentry/browser';

export const LazyLoader: FunctionComponent = ({ children }) => {
  const { isSSR } = useNotNullableContext(AppContext);

  if (isSSR) {
    return null;
  }

  return (
    <ErrorBoundary fallbackContent={null} onError={captureException}>
      <React.Suspense fallback={<Loading />}>{children}</React.Suspense>
    </ErrorBoundary>
  );
};
